import { useState, useEffect } from 'react';

interface Purchase {
  name: string;
  time: string;
  id: number;
}

const mockPurchases: Purchase[] = [
  { name: 'Carlos M.', time: 'hace 2 min', id: 1 },
  { name: 'Ana R.', time: 'hace 5 min', id: 2 },
  { name: 'Luis P.', time: 'hace 8 min', id: 3 },
  { name: 'María G.', time: 'hace 12 min', id: 4 },
  { name: 'Jorge S.', time: 'hace 15 min', id: 5 },
  { name: 'Patricia L.', time: 'hace 18 min', id: 6 },
  { name: 'Roberto C.', time: 'hace 22 min', id: 7 },
  { name: 'Sofía V.', time: 'hace 25 min', id: 8 },
  { name: 'Diego F.', time: 'hace 30 min', id: 9 },
  { name: 'Valentina T.', time: 'hace 35 min', id: 10 },
];

export default function FloatingButton() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [totalPurchases] = useState(47);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 8000);
    return () => clearTimeout(initialTimer);
  }, []);

  useEffect(() => {
    if (!isVisible || isClosed) return;
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % mockPurchases.length);
        setIsAnimating(false);
      }, 900);
    }, 18000);
    return () => clearInterval(interval);
  }, [isVisible, isClosed]);

  const handleClose = () => {
    setIsAnimating(true);
    setTimeout(() => {
      setIsClosed(true);
      setIsVisible(false);
    }, 300);
  };

  if (!isVisible || isClosed) return null;

  const currentPurchase = mockPurchases[currentIndex];

  return (
    <div
      className={`fixed bottom-4 left-3 z-50 transition-all duration-700 ${
        isAnimating ? 'opacity-0 translate-y-3' : 'opacity-100 translate-y-0'
      }`}
      style={{ maxWidth: '210px' }}
    >
      <div className="relative bg-white border-2 border-black rounded-2xl shadow-[4px_4px_0px_0px_#000] overflow-hidden">

        {/* Header strip */}
        <div className="bg-black px-3 py-1.5 flex items-center justify-between">
          <div className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-orange-400 animate-pulse inline-block"></span>
            <span className="text-white text-[10px] font-bold uppercase tracking-wide">En vivo</span>
          </div>
          <button
            onClick={handleClose}
            className="w-4 h-4 flex items-center justify-center text-white/70 hover:text-white transition-colors cursor-pointer"
            aria-label="Cerrar"
          >
            <i className="ri-close-line text-xs"></i>
          </button>
        </div>

        {/* Body */}
        <div className="px-3 py-2.5">
          <div className="flex items-center gap-2">
            {/* Avatar */}
            <div className="w-8 h-8 rounded-full bg-orange-100 border-2 border-black flex items-center justify-center flex-shrink-0">
              <i className="ri-fire-fill text-orange-500 text-sm"></i>
            </div>

            <div className="flex-1 min-w-0">
              <p className="text-black font-bold text-xs leading-tight truncate">
                {currentPurchase.name}
              </p>
              <p className="text-gray-600 text-[10px] leading-tight">
                acaba de comprar
              </p>
              <p className="text-orange-500 text-[10px] font-semibold mt-0.5">
                {currentPurchase.time}
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t-2 border-black/10 mt-2 pt-2 flex items-center gap-1.5">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-group-fill text-black text-xs"></i>
            </div>
            <p className="text-[10px] text-gray-600 leading-tight">
              <span className="font-black text-black">{totalPurchases}</span> personas ya accedieron
            </p>
          </div>
        </div>

        {/* Bottom accent */}
        <div className="h-1 bg-gradient-to-r from-orange-400 via-orange-500 to-red-500"></div>
      </div>
    </div>
  );
}
